













































































































































import { PartyModel, TenantUserModel, WorkTaskEvaluationGroupModel, WorkTaskEvaluationModel, WorkTaskRuleModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { Guid } from '@/libs/common/functions/guid';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { workTaskEvaluationsGroupsStore } from '@/libs/work-task-evaluation-groups/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { partiesStore } from '../+state/store';

@Component({})
export default class EvaluationDialog extends Page {

    workTaskEvaluationsGroup: WorkTaskEvaluationGroupModel | null = null;
    previousWorkTaskEvaluationGroup: WorkTaskEvaluationGroupModel | null = null;
    workTaskEvaluations: WorkTaskEvaluationModel[] = [];
    previousWorkTaskEvaluations: Array<WorkTaskEvaluationModel | null> = [];

    deleteDialog = false;
    deleting = false;

    unsavedDialog = false;
    changed = false;

    isNew = false;
    dialog = false;
    valid = false;
    saving = false;
    editMode = false;

    partyId: string | null = null;

    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];

    /* Auth variables */
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    get party(): PartyModel {
        return {...partiesStore.useGetter(CrudGetter.Detail, this.partyId)};
    }

    @Prop() workTaskRules!: WorkTaskRuleModel[] | null;

    @Ref() form!: any;
    
    get printing(): boolean {
        return workTaskEvaluationsGroupsStore.useGetter(CrudGetter.Printing);
    }

    open (id: string | null = null, partyId: string | null = null, item: WorkTaskEvaluationGroupModel | null = null, previousWorkTaskEvaluationGroup: WorkTaskEvaluationGroupModel | null = null) {
        this.dialog = true;
        this.changed = false;
        this.partyId = partyId;
        partiesStore.dispatch(CrudAction.Get, { id: partyId, key: partyId });
        this.workTaskEvaluationsGroup = null;
        this.workTaskEvaluations = [];
        this.previousWorkTaskEvaluationGroup = null;
        this.previousWorkTaskEvaluations = [];
        if (id == null && item == null) {
            this.isNew = true;
            this.editMode = true;
            this.workTaskEvaluationsGroup = {
                id: Guid.EmptyGuid(),
                partyId: partyId,
                time: moment().format("YYYY-MM-DDTHH:mm:ss"),
                workTaskEvaluations: [],
                tenantUserId: this.tenantUser.id,
                tenantUser: this.tenantUser
            } as WorkTaskEvaluationGroupModel;
            this.workTaskEvaluations = this.workTaskRules!.sort((a: WorkTaskRuleModel, b: WorkTaskRuleModel) => {
                return ('' + a.catalogueItem!.name!).localeCompare(b.catalogueItem!.name!);
            }).map((e: WorkTaskRuleModel) => {
                return {
                    id: Guid.EmptyGuid(),
                    workTaskEvaluationGroupId: Guid.EmptyGuid(),
                    workTaskRuleId: e.id,
                    workTaskRule: e,
                    description: "",
                    createdAt: moment().format("YYYY-MM-DDTHH:mm:ss")
                } as WorkTaskEvaluationModel;
            });
            this.previousWorkTaskEvaluationGroup = previousWorkTaskEvaluationGroup;
            this.previousWorkTaskEvaluations = this.workTaskRules!.map((e: WorkTaskRuleModel) => {
                return previousWorkTaskEvaluationGroup?.workTaskEvaluations?.find(x => x.workTaskRuleId == e.id) ?? null;
            });
        }
        else if (item != null) {
            this.isNew = false;
            this.editMode = false;
            this.workTaskEvaluationsGroup = item;
            this.workTaskEvaluations = this.workTaskEvaluationsGroup.workTaskEvaluations!.sort((a: WorkTaskEvaluationModel, b: WorkTaskEvaluationModel) => {
                return ('' + a.workTaskRule!.catalogueItem!.name!).localeCompare(b.workTaskRule!.catalogueItem!.name!);
            });
            this.previousWorkTaskEvaluationGroup = previousWorkTaskEvaluationGroup;
            this.previousWorkTaskEvaluations = this.workTaskEvaluationsGroup.workTaskEvaluations!.map((e: WorkTaskEvaluationModel) => {
                return previousWorkTaskEvaluationGroup?.workTaskEvaluations?.find(x => x.workTaskRuleId == e.workTaskRuleId) ?? null;
            });
        }
        else if (id != null) {
            this.dialog = true;
            this.isNew = false;
            this.editMode = false;
            workTaskEvaluationsGroupsStore.dispatch(CrudAction.Get, { id: id, key: "EvaluationDialog" });
            this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.Get, "EvaluationDialog").then((e: WorkTaskEvaluationGroupModel) => {
                this.workTaskEvaluationsGroup = e;
                this.workTaskEvaluations = this.workTaskEvaluationsGroup!.workTaskEvaluations!.sort((a: WorkTaskEvaluationModel, b: WorkTaskEvaluationModel) => {
                    return ('' + a.workTaskRule!.catalogueItem!.name!).localeCompare(b.workTaskRule!.catalogueItem!.name!);
                });
                workTaskEvaluationsGroupsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskEvaluationGroupModel>({ field: "time", index: 1, order: "desc" }, [
                    { field: "partyId", op: "eq", comparand: this.workTaskEvaluationsGroup!.partyId! },
                    { field: "time", op: "lt", comparand: this.workTaskEvaluationsGroup!.time! },
                ], {
                    pageIndex: 1,
                    pageSize: 1
                }, false, "EvaluationDialog"));
                this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.GetAll, "EvaluationDialog").then((e: Array<WorkTaskEvaluationGroupModel>) => {
                    if (e.length > 0) {
                        this.previousWorkTaskEvaluationGroup = e[0];
                        this.previousWorkTaskEvaluations = this.workTaskEvaluationsGroup!.workTaskEvaluations!.map((e: WorkTaskEvaluationModel) => {
                            return this.previousWorkTaskEvaluationGroup?.workTaskEvaluations?.find(x => x.workTaskRuleId == e.workTaskRuleId) ?? null;
                        });
                    }
                });
            })
        }
    }

    save () {
        if (this.form.validate()) {
            if (this.workTaskEvaluationsGroup?.id == Guid.EmptyGuid()) {
                this.saving = true;
                this.workTaskEvaluationsGroup!.workTaskEvaluations = this.workTaskEvaluations;
                workTaskEvaluationsGroupsStore.dispatch(CrudAction.Create, { item: this.workTaskEvaluationsGroup });
                this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.Create).then((n: WorkTaskEvaluationGroupModel) => {
                    this.saving = false;
                    this.editMode = false;
                    this.$emit("changed");
                    this.dialog = false;
                }).catch((e: any) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                this.saving = true;
                this.workTaskEvaluationsGroup!.workTaskEvaluations = this.workTaskEvaluations;
                workTaskEvaluationsGroupsStore.dispatch(CrudAction.Update, { item: this.workTaskEvaluationsGroup });
                this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.Update).then((n: WorkTaskEvaluationGroupModel) => {
                    this.saving = false;
                    this.editMode = false;
                    this.$emit("changed");
                    this.dialog = false;
                }).catch((e: any) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteItemClick () {
        this.deleteDialog = true;
    }

    deleteItem () {
        this.deleting = true;
        workTaskEvaluationsGroupsStore.dispatch(CrudAction.Delete, { id: this.workTaskEvaluationsGroup!.id });
        this.subscribe(workTaskEvaluationsGroupsStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.$emit("changed");
            this.dialog = false;
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

    close () {
        if (!this.changed)
            this.dialog = false;
        else 
            this.unsavedDialog = true;
    }

    printClick () {
        workTaskEvaluationsGroupsStore.dispatch(CrudAction.Print, { id: this.workTaskEvaluationsGroup!.id });
    }

}
